import { ExternalLink } from 'lucide-react';

function IssueIdLink({ issueId, className = '' }) {
  const mantisUrl = `https://mantis.gmed.it/view.php?id=${issueId}`;
  
  return (
    <a
      href={mantisUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center gap-1 text-[rgb(59,130,246)] hover:text-[rgb(59,130,246)]/80 hover:underline transition-colors ${className}`}
      data-testid={`issue-link-${issueId}`}
    >
      #{issueId}
      <ExternalLink className="h-3 w-3" />
    </a>
  );
}

export default IssueIdLink;
